import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  NotificationDetailsResponse,
  NotificationsListResponse,
  PaginationPayload,
  UpdateNotificationPayload,
} from './types'

const API_ENDPOINT = '/api/v1/reminder'

const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['notificationsApi'],
  endpoints: (builder) => ({
    getNotificationsList: builder.query<NotificationsListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: NotificationsListResponse) => {
        return response
      },
    }),

    getNotificationById: builder.query<NotificationDetailsResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/${id}/`,
        method: 'GET',
      }),
    }),

    addNotification: builder.mutation<void, UpdateNotificationPayload['data']>({
      query: (data) => ({
        url: `${API_ENDPOINT}/`,
        method: 'POST',
        data: data,
      }),
    }),

    deleteNotification: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/${id}/`,
        method: 'DELETE',
      }),
    }),

    updateNotification: builder.mutation<void, UpdateNotificationPayload>({
      query: ({ data, id }) => ({
        url: `${API_ENDPOINT}/${id}/`,
        method: 'PATCH',
        data: data,
      }),
    }),
  }),
})

export const {
  useGetNotificationsListQuery,
  useDeleteNotificationMutation,
  useAddNotificationMutation,
  useUpdateNotificationMutation,
  useGetNotificationByIdQuery,
} = notificationsApi
export default notificationsApi
